export default __webpack_public_path__ + "static/withoutanubis-d6668feb0ad16d661862eb9232309086.png";